import { render, staticRenderFns } from "./LiberdadeSocial.vue?vue&type=template&id=37806b23&scoped=true"
import script from "./LiberdadeSocial.vue?vue&type=script&lang=js"
export * from "./LiberdadeSocial.vue?vue&type=script&lang=js"
import style0 from "./LiberdadeSocial.vue?vue&type=style&index=0&id=37806b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37806b23",
  null
  
)

export default component.exports